import { ref } from 'vue'

export interface ConfirmOptions {
    title?: string
    message?: string
    severity?: 'primary' | 'danger'
    confirmLabel?: string
    cancelLabel?: string
}

interface PendingConfirm extends ConfirmOptions {
    resolve: (value: boolean) => void
}

const current = ref<PendingConfirm | null>(null)

export function useConfirm() {
    function confirm(options: ConfirmOptions): Promise<boolean> {
        return new Promise(resolve => {
            current.value = { ...options, resolve }
        })
    }

    function _resolve(value: boolean) {
        if (current.value) {
            current.value.resolve(value)
            current.value = null
        }
    }

    return { confirm, current, _resolve }
}
